"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The TestCode model module.
 * @module model/TestCode
 * @version 0.2.0
 */
var TestCode = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>TestCode</code>.
   * @alias module:model/TestCode
   */
  function TestCode() {
    _classCallCheck(this, TestCode);

    TestCode.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(TestCode, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>TestCode</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TestCode} obj Optional instance to populate.
     * @return {module:model/TestCode} The populated <code>TestCode</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new TestCode();

        if (data.hasOwnProperty('testID')) {
          obj['testID'] = _ApiClient["default"].convertToType(data['testID'], 'String');
        }

        if (data.hasOwnProperty('testName')) {
          obj['testName'] = _ApiClient["default"].convertToType(data['testName'], 'String');
        }
      }

      return obj;
    }
  }]);

  return TestCode;
}();
/**
 * @member {String} testID
 */


TestCode.prototype['testID'] = undefined;
/**
 * @member {String} testName
 */

TestCode.prototype['testName'] = undefined;
var _default = TestCode;
exports["default"] = _default;